<template>
  <div class="mt-4">
    <template v-if="this.$i18n.locale === 'ru'">
      <PrivacyNestRu />
    </template>
    <template v-else>
      <PrivacyNestEn />
    </template>
  </div>
</template>

<script>
/* eslint-disable func-names */
import PrivacyNestRu from '../components/Policy/PrivacyNestRu.vue'
import PrivacyNestEn from '../components/Policy/PrivacyNestEn.vue'

export default {
  components: {
    PrivacyNestRu,
    PrivacyNestEn,
  },
  watch: {
    '$i18n.locale': function (val) {
      if (val) {
        this.$router.replace(`/policy/nest/privacy-policy-for-access-to-google-apis/${val}`)
      }
    },
  },
  mounted() {
    this.$root.$data.selectLang(this.$route.params.lang, this)
  },
}
</script>

<style>
.code,
code {
  background: rgba(135, 131, 120, 0.15);
  border-radius: 3px;
  padding: 0.2em 0.4em;
  border-radius: 3px;
  font-size: 85%;
  tab-size: 2;
}

code {
  color: #eb5757;
}

.code {
  padding: 1.5em 1em;
}

.code-wrap {
  white-space: pre-wrap;
  word-break: break-all;
}

.code > code {
  background: none;
  padding: 0;
  font-size: 100%;
  color: inherit;
}

blockquote {
  font-size: 1.25em;
  margin: 1em 0;
  padding-left: 1em;
  border-left: 3px solid rgb(55, 53, 47);
}
</style>
